module.exports = __webpack_public_path__ + "static/img/3.ca799a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/3.png
// module id = bult
// module chunks = 0